import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ActionSheetController, MenuController } from '@ionic/angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit, OnDestroy{
  routeSubsc: Subscription;

  show = {
    home: true,
    terms: false,
    privacy: false,
    contact: false
  };

  currentNavPath: string;

  constructor(
    private menuCtrl: MenuController,
    private router: Router,
    private actionSheetController:ActionSheetController) {
    
    
  }

  ngOnInit(){
    this.menuCtrl.enable(false);

    this.routeSubsc = this.router.events.subscribe((s) => {
      if (s instanceof NavigationEnd) {
        setTimeout(()=>{
          this.changeNavPath(s.urlAfterRedirects);
        }, 300);
      }

      
    });
  }

  changeNavPath(path:string) {
    if (!this.currentNavPath || this.currentNavPath != path) {
      this.currentNavPath = path;
      console.log('new currentNavPath', this.currentNavPath);
    }
  }  

  ngOnDestroy() {
    console.log('[home] ngOnDestroy: ');
    this.routeSubsc.unsubscribe();
  }
}
